import React, { useContext } from 'react'
import { CalculatorStepsContext } from '../Store/CalculatorStepsContext'
import { StepIndicator } from './StepIndicator';
import { StepLabel } from './Step';


interface Props {
    steps: Array<StepLabel>;
}

export const CalculatorStepIndicator = (props: Props) => {
    const { steps } = useContext(CalculatorStepsContext);
    return (
        <StepIndicator steps={props.steps} stepIndex={steps.stepIndex} />
    )
}
